import Button from '@/components/shared/Button/Button';

const UnavailableHours = ({ addTimeslot }: { addTimeslot: () => void }) => {
  return (
    <div className="flex gap-2 items-center">
      <p className="text-neutral-40">Unavailable</p>
      <Button
        isIcon
        variant="transparent"
        className="w-8 h-8 border-none"
        onClick={addTimeslot}
        prefixIcon={<img src={'/icons/plus.svg'} />}
      />
    </div>
  );
};

export default UnavailableHours;
